import AccountRemoveCard from './AccountRemoveCard';

export default AccountRemoveCard;
